import {mainQuery} from '@github-ui/react-core/future/main-query'

import {copilotAgentsAppBuilder} from '../../config/app-builder'
import type {CopilotAgentsCustomizePayload} from '../../types/copilot-agents-customize-payload'

// Customize ships only in the one_copilot experience, so there is no legacy
// /copilot/agents path variant the way Spaces has one.
export const copilotAgentsCustomizeRoute = copilotAgentsAppBuilder.createQueryRouteConfig(
  'copilotAgentsCustomizeRoute',
  {
    path: '/copilot/customize',
    // eslint-disable-next-line @github-ui/github-monorepo/require-query-schema -- The connectors catalog is client-side mock data with no Protobuf schema yet.
    queries: [mainQuery<CopilotAgentsCustomizePayload>()],
  },
)
